<script lang="typescript">
 import RadioOption from './RadioOption.svelte';
 import { state, setState } from '../stores.js';
 import { MessageType } from "../types";
 import type { LensVariant } from "../types";
 import {
     computeTotalPrice,
     getCurrency,
     getBaseLensObject
 } from '../utils';
 export let primaryVariant: LensVariant;
 export let availableSecondaryVariants: LensVariant[];

 const setSecondaryVariant = (secondaryVariantIndex: number | null) => setState({
     message: MessageType.SET_SECONDARY_VARIANT,
     secondaryVariantIndex: secondaryVariantIndex,
 });

 const getPriceDisplay = () => {
     const price = computeTotalPrice(
	 getBaseLensObject($state.focalType),
	 $state.baseLensKey,
	 primaryVariant,
	 null,
	 $state.region,
     );
     return `${getCurrency($state)}${price}`;
 };
</script>

{#if availableSecondaryVariants.length}
    <div class="w-full">
	<h3>Order your lenses</h3>
	<form>
	    <ul class="list-none">
		<li>
		    <label for="radio-default">
			<input
			    type="radio"
			    value="{null}"
			    name="default"
			    id="radio-default"
			    on:change="{() => setSecondaryVariant(null)}"
			    checked="{$state.secondaryVariantIndex === null}"
			/>
			<span class="checkmark"></span>
				<span class="text-2xl px-2">
					As listed above ({getPriceDisplay()})
				</span>
			
		    </label>
		</li>
		{#each availableSecondaryVariants as variant, i}
		    <RadioOption
			index="{i}"
			secondaryVariant="{variant}"
			onChange="{setSecondaryVariant}"
			{primaryVariant}
		    />
		{/each}
	    </ul>
	</form>
    </div>
{/if}

<style>
 li {
     @apply border-gray-200 border-2 rounded-md text-xl hover:border-primary-light;
     @apply transition-colors duration-300;
 }

 label {
     @apply block relative pl-12 cursor-pointer p-4;
 }

 input {
     @apply absolute opacity-0 w-0 h-0 cursor-pointer;
 }

 input:checked ~ .checkmark:after {
     @apply block;
 }

 .checkmark {
     @apply absolute top-4 left-4 h-6 w-6 bg-gray-200 rounded-full;
     @apply transition-colors duration-300;
 }

 .checkmark:after {
     @apply absolute hidden;
     content: "";
 }

 label .checkmark:after {
     @apply h-6 w-6 rounded-full border-8 border-primary-light bg-background;
 }
</style>
